var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereumColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    size: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7313 21.1023L15.7333 12.1294L7.11983 15.9092L15.7313 21.1023Z",
    fill: "#90A9EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7799 12.1294L15.7779 21.1044L24.3929 15.9092L15.7799 12.1294Z",
    fill: "#C6B4F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3841 15.8587L15.7779 1.71851L15.7799 12.083L24.3841 15.8587Z",
    fill: "#C7F8F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7787 22.57L15.7779 29.4968L24.4002 17.6262L15.7787 22.57Z",
    fill: "#C5B2F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7313 29.4921L15.7321 22.5685L7.11257 17.6262L15.7313 29.4921Z",
    fill: "#EACEC6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12875 15.8589L15.7333 12.0831L15.7313 1.72412L7.12875 15.8589Z",
    fill: "#EACEC4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7561 21.1668L15.773 21.1574L24.4517 15.9237L24.4694 15.9132L15.777 1.63018L15.7569 1.6001L15.7363 1.63018L7.0431 15.9132L15.7395 21.1577L15.7561 21.1672V21.1668ZM24.384 15.8588L15.7798 12.0831L15.7782 1.7186L24.384 15.8588ZM15.7798 12.1294L24.3929 15.9092L15.7782 21.1045L15.7798 12.1294ZM15.7315 21.1023L7.12006 15.9092L15.7335 12.1294L15.7315 21.1023ZM7.12892 15.8588L15.7315 1.72404L15.7335 12.0831L7.12892 15.8588Z",
    fill: "#686DCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95647 17.4873L15.7408 29.5807L15.7565 29.6003L15.7726 29.5807L24.5565 17.4873L15.7565 22.5333L6.95647 17.4873ZM15.7315 29.4923L7.1128 17.6265L15.7323 22.5688L15.7315 29.4923ZM15.7786 22.5702L24.4001 17.6265L15.7782 29.497L15.779 22.5702H15.7786Z",
    fill: "#686DCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumColor);
export default __webpack_public_path__ + "static/media/ethereumColor.1e2e8d3e32a7ae9cadc7a6f9e3c68b4f.svg";
export { ForwardRef as ReactComponent };